import { Component, Input } from '@angular/core';
import { SvgComponent } from '../svg-component/svg-component.component';

export enum PillStatus {
  Error = 'error',
  Pending = 'pending',
  Resolving = 'resolving',
  Success = 'success',
}

@Component({
  selector: 'app-rounded-pill',
  templateUrl: 'rounded-pill.component.html',
  styleUrl: 'rounded-pill.component.scss',
  imports: [SvgComponent],
})
export class RoundedPillComponent {
  _total!: number;
  get total(): number {
    return this._total;
  }
  @Input() set total(value: number) {
    this._total = value;
    this.getFilledPercentage();
  }
  _current!: number | string;
  get current(): number | string {
    return this._current;
  }
  @Input() set current(value: number | string) {
    this._current = value;
    this.getFilledPercentage();
  }
  _newAdded!: number | string;
  get newAdded(): number | string {
    return this._newAdded;
  }
  @Input() set newAdded(value: number | string) {
    this._newAdded = value;
    this.getFilledPercentage();
  }
  _regression!: number | string;
  get regression(): number | string {
    return this._regression;
  }
  @Input() set regression(value: number | string) {
    this._regression = value;
    this.getFilledPercentage();
  }
  @Input() status?: PillStatus;
  @Input() height: number = 24;
  @Input() showPercentage?: boolean;
  @Input() text?: string | number;
  @Input() showText?: boolean = true;
  @Input() isClickable?: boolean = true;
  @Input() mode: 'dark' | 'light' = 'dark';
  @Input() showStatusBackground?: boolean = false;
  @Input() isGradient?: boolean;
  @Input() flatProgressBar?: boolean;
  filledPercentage!: number;
  regressionPercentage!: number;
  newPercentage!: number;

  get backgroundColor(): string {
    if (!this.showStatusBackground) {
      return '';
    }
    if (this.filledPercentage > 80) {
      return 'var(--color-severity-excellent)';
    }
    if (this.filledPercentage > 60) {
      return 'var(--color-severity-good)';
    }
    if (this.filledPercentage > 40) {
      return 'var(--color-severity-medium)';
    }
    return 'var(--color-severity-low)';
  }

  get borderColor(): string {
    if (this.mode === 'light') {
      return 'pill-light';
    }
    switch (this.status) {
      case PillStatus.Pending:
        return 'pill-orange-border';
      case PillStatus.Error:
        return 'pill-red-border';
      case PillStatus.Resolving:
        return 'pill-yellow-border';
      case PillStatus.Success:
        return 'pill-green-border';
      default:
        return 'pill-gray-border';
    }
  }

  getFilledPercentage(): void {
    if (this.total === 0) {
      this.filledPercentage = 0;
      return;
    }
    if (this.regression) {
      this.regressionPercentage =
        (+this.regression * 100) / (this.total || 100);
      this.filledPercentage = (+this.current * 100) / (this.total || 100);
    } else {
      this.regressionPercentage = 0;
      this.filledPercentage = (+this.current * 100) / (this.total || 100);
      const newPercentageOfTotal = (+this.newAdded * 100) / (this.total || 100);
      this.newPercentage = (newPercentageOfTotal * 100) / this.filledPercentage;
    }
  }
}
